import React from 'react'; 
 import './index.css';
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from 'courseLiveInfoStore';
import  flvjs from 'flv.js';
import  Hls from 'hls.js'; 
import 'dplayer/dist/DPlayer.min.css';
import DPlayer from 'dplayer';
import { Toast } from 'antd-mobile';

 
class ContentList  extends React.Component{
  constructor(props){
    super(props); 
    this.state={
       index:0, 
       type:'',
       hls: ''
    }
  }
  componentWillReceiveProps(nextProps){
    let _this = this
    setTimeout(()=>{
      const  liveinfo = this.props.liveinfo
      let  hlsUrl = liveinfo&&liveinfo.live&&liveinfo.live.output.m3u8
      if (!this.props.isLiveing) hlsUrl = ''
      console.log('---------',hlsUrl)
      try {
        if (this.state.hls) this.state.hls.destroy()
        let hlsdp = new DPlayer({
         container: document.getElementById('dplayer')?document.getElementById('dplayer'):null,
         screenshot: false,
         live: true,
         autoplay: true, 
            video: {
              url: hlsUrl,
              type: 'customHls',
              customType: { 
                  customHls: function (video, player) {
                   const hls = new Hls()
                   hls.loadSource(video.src)
                   hls.attachMedia(video)
                   _this.setState({hls: hls})
                }
              }
            } 
        }); 
      } 
      catch(err){
        Toast.info('暂时无法播放直播', 3);
      }  
    },600)
  }

    componentWillUnmount() {
        if (this.state.hls) this.state.hls.destroy()
    }
  render(){ 
    return (
      <div className="dplayer-wrapper">
        <div id="dplayer"></div>
      </div>
    )
  }
}
 
  
const mapState = (state) => ({
})
export default connect(mapState, null)(ContentList);
 

 